import { SubjectItem } from "@/base/NewselaGlobalLayoutV2/NavigationBar/SubjectItems/SubjectItem/SubjectItem";

export { SubjectItem };
